import { a as r } from "./an-object.js";
import { o as t } from "./ordinary-to-primitive.js";
var i = TypeError,
  o = function o(_o) {
    if (r(this), "string" === _o || "default" === _o) _o = "string";else if ("number" !== _o) throw i("Incorrect hint");
    return t(this, _o);
  };
export { o as d };